import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

/**
 * Created by Jerker Nord on 2018-12-10.
 */

export class ThorReelBackgroundView extends BaseView {

    private _backgroundTextureName:string;
    private _reelBackground:PIXI.Container;

    constructor(resourcesGroup:ResourcesGroupName, backgroundTextureName:string) {
        super(resourcesGroup);
        this._backgroundTextureName = backgroundTextureName;
        this._reelBackground = new PIXI.Container();
    }

    protected initAnimations():void {
        const backgroundTexture:PIXI.Texture = GameResources.getTextures(this._backgroundTextureName)[0];
        const background01:PIXI.Sprite = new PIXI.Sprite(backgroundTexture);
        const background02:PIXI.Sprite = new PIXI.Sprite(backgroundTexture);
        const background03:PIXI.Sprite = new PIXI.Sprite(backgroundTexture);
        this._reelBackground.addChild(background02);
        background01.position.y -= (background02.height);
        background03.position.y += (background02.height);
        this._reelBackground.addChild(background01);
        this._reelBackground.addChild(background03);
        this.addChild(this._reelBackground);
    }
}